import { IOfferType } from '../../../types/offerTypeList';
import { FOfferType } from '../../../utils/category';

export const OFFER_TYPES_SALE_COMMERCIAL: IOfferType[][] = [
  [
    { label: 'Офис', value: FOfferType.Office },
    { label: 'Торговая площадь', value: FOfferType.TradeArea },
    { label: 'Склад', value: FOfferType.Warehouse },
    { label: 'Помещение свободного назначения', value: FOfferType.FreeAppointmentObject },
    { label: 'Общепит', value: FOfferType.PublicCatering },
    { label: 'Производство', value: FOfferType.Manufacture },
    { label: 'Автосервис', value: FOfferType.AutoService },
    { label: 'Здание', value: FOfferType.Building },
    { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
    { label: 'Арендный бизнес', value: FOfferType.RentalBusiness },
    { label: 'Готовый бизнес', value: FOfferType.ReadyBusiness },
  ],
  [{ label: 'Коммерческая земля', value: FOfferType.CommercialLand }],
];
